/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO React Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent, info: lightInfo, secondary: lightSecondary, grey: lightGrey } = colors.light;
const { info: darkInfo, secondary: darkSecondary, grey: darkGrey } = colors.dark;
const { size } = typography;

export default {
  base: ({ theme }) => {
    const isDark = theme?.palette?.mode === "dark";
    const info = isDark ? darkInfo : lightInfo;
    const grey = isDark ? darkGrey : lightGrey;
    return {
      backgroundColor: transparent.main,
      height: "max-content",
      color: isDark ? grey[600] : info.main,
      boxShadow: "none",
      padding: `${pxToRem(6)} ${pxToRem(12)}`,

      "&:hover": {
        backgroundColor: transparent.main,
        boxShadow: "none",
        color: isDark ? grey[700] : info.focus,
      },

      "&:focus": {
        boxShadow: "none",
        color: isDark ? grey[700] : info.focus,
      },

      "&:active, &:active:focus, &:active:hover": {
        opacity: 0.85,
        boxShadow: "none",
      },

      "&:disabled": {
        color: isDark ? grey[400] : lightGrey[600],
        boxShadow: "none",
      },

      "& .material-icons, .material-icons-round, svg, span": {
        fontSize: `${pxToRem(16)} !important`,
      },
    };
  },

  small: {
    fontSize: size.xs,

    "& .material-icons, .material-icons-round, svg, span": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    fontSize: size.sm,

    "& .material-icons, .material-icons-round, svg, span": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: ({ theme }) => {
    const isDark = theme?.palette?.mode === "dark";
    const info = isDark ? darkInfo : lightInfo;
    return {
      color: info.main,
      backgroundColor: transparent.main,

      "&:hover": {
        color: info.focus,
        backgroundColor: transparent.main,
      },

      "&:focus:not(:hover)": {
        color: info.focus,
        backgroundColor: transparent.main,
        boxShadow: "none",
      },
    };
  },

  secondary: ({ theme }) => {
    const isDark = theme?.palette?.mode === "dark";
    const secondary = isDark ? darkSecondary : lightSecondary;
    return {
      color: secondary.focus,
      backgroundColor: transparent.main,

      "&:hover": {
        color: secondary.focus,
        backgroundColor: transparent.main,
      },

      "&:focus:not(:hover)": {
        color: secondary.focus,
        backgroundColor: transparent.main,
        boxShadow: "none",
      },
    };
  },
};
